import type { Category } from "./Category";

export class CategorySectionModel {
  categories: Category[];

  constructor(categories: Category[] = []) {
    this.categories = categories;
  }

  addCategory = (category: Category) => {
    this.categories.push(category);
  };

  getCategories = () => {
    return this.categories.filter((category) => this.checkValidField(category));
  };

  checkValidField = (category: Category) =>
    !!(category.id && category.image && category.title);
}
